import * as userConstants from "@/core/models/usersAndPermissions";
import { routes } from "@/routing/routes";
import { isWarehouseCheckinDisabled } from "@/routing/guards/checkForWarehouseCheckinRequirement";

const router = [
  {
    path: routes.stocks.path,
    name: routes.stocks.name,
    component: () =>
      import(/* webpackChunkName: "stocks" */ "@/apps/dashboard/itemLocation/view/pages/Stocks/Stocks.vue"),
    props: (route: any) => ({
      alert: route.query.alert ? JSON.parse(route.query.alert) : null,
    }),
    meta: {
      permission: userConstants.ROLE_STOCK_MANAGE,
      routeKeyToPreventReloadMainLayout: routes.stocks.path,
    },
  },
  {
    path: routes.editStock.path,
    name: routes.editStock.name,
    component: () =>
      import(/* webpackChunkName: "stocks" */ "@/apps/dashboard/itemLocation/view/pages/Stock/Stock.vue"),
    meta: {
      permission: userConstants.ROLE_STOCK_MANAGE,
    },
    props: true,
  },
  {
    path: routes.createStock.path,
    name: routes.createStock.name,
    component: () =>
      import(/* webpackChunkName: "stocks" */ "@/apps/dashboard/itemLocation/view/pages/Stock/Stock.vue"),
    meta: {
      permission: userConstants.ROLE_STOCK_MANAGE,
    },
    props: true,
  },
  {
    path: routes.itemsStock.path,
    name: routes.itemsStock.name,
    component: () =>
      import(/* webpackChunkName: "itemsstock" */ "@/apps/dashboard/itemLocation/view/pages/ItemsInStock/Items.vue"),
    props: (route: any) => ({
      alert: route.query.alert ? JSON.parse(route.query.alert) : null,
    }),
    meta: {
      permission: userConstants.ROLE_ITEMS_STOCK_READ,
    },
  },
  {
    path: routes.editItemsStock.path,
    name: routes.editItemsStock.name,
    component: () =>
      import(
        /* webpackChunkName: "itemsstock" */ "@/apps/dashboard/itemLocation/view/pages/EditItemInStock/EditItemInStock.vue"
      ),
    meta: {
      permission: userConstants.ROLE_ITEMS_STOCK_READ,
    },
    props: true,
  },
  {
    path: routes.checkinWarehouse.path,
    name: routes.checkinWarehouse.name,
    component: () =>
      import(
        /* webpackChunkName: "db-wh-check" */ "@/apps/dashboard/itemLocation/view/pages/WarehouseCheckin/WarehouseCheckin.vue"
      ),
    meta: {
      permission: userConstants.ROLE_WAREHOUSE_CHECKIN_PAGE,
    },
    beforeEnter: () => {
      if (isWarehouseCheckinDisabled()) {
        return { name: routes.home.name };
      }

      return;
    },
  },
  {
    path: routes.confirmationCheckin.path,
    name: routes.confirmationCheckin.name,
    component: () =>
      import(
        /* webpackChunkName: "db-wh-conf" */ "@/apps/dashboard/itemLocation/view/pages/WarehouseCheckinConfirmation/WarehouseCheckinConfirmation.vue"
      ),
    meta: {
      permission: userConstants.ROLE_WAREHOUSE_CHECKIN_PAGE,
    },
    props: (route: any) => ({
      itemId: route.params?.itemId,
      buybackIdentificationNumber: route.query?.buybackIdentificationNumber,
    }),
    beforeEnter: () => {
      if (isWarehouseCheckinDisabled()) {
        return { name: routes.home.name };
      }

      return;
    },
  },
];

export default router;
